import './Hero.css';
import './Contact.css';

interface HeroProps {
  name: string;
  title: string;
  bio: string;
  education: string[];
  skills: string[];
  contact: {
    github: string;
    linkedin: string;
  };
}

function Hero({ name, title, bio, education, skills, contact }: HeroProps) {
  return (
    <section className="hero">
      <h1 className="hero-name">{name}</h1>
      <h2 className="hero-title">{title}</h2>

      <div className="contact-links">
        <a
          href={contact.github}
          className="contact-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <a
          href={contact.linkedin}
          className="contact-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
      </div>

      <p className="hero-bio">Hi. I'm Will, a Computer Systems Engineer. I have a passion for low-level software development, working with embedded systems.</p>

      <div className="hero-education">
        <h3>Education</h3>
        <ul className="education-list">
          {education.map((edu) => (
            <li key={edu}>{edu}</li>
          ))}
        </ul>
      </div>

      <div className="hero-skills">
        <h3>Skills</h3>
        <ul className="skills-list">
          {skills.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Hero;
